"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Snackbar = exports.positionOptions = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const Theme_1 = require("../../Theme/Theme");
exports.positionOptions = [
    'topLeft',
    'topCenter',
    'topRight',
    'bottomLeft',
    'bottomCenter',
    'bottomRight',
];
const fadeIn = (0, Theme_1.keyframes) `
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;
const fadeOut = (0, Theme_1.keyframes) `
  0% {
    opacity: 1;
  }
  95% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`;
const topLeft = (0, Theme_1.css) `
  top: 0;
  left: 0;
`;
const topCenter = (0, Theme_1.css) `
  top: 0;
  left: 50%;
  transform: translateX(-50%);
`;
const topRight = (0, Theme_1.css) `
  top: 0;
  right: 0;
`;
const bottomLeft = (0, Theme_1.css) `
  bottom: 0;
  left: 0;
`;
const bottomCenter = (0, Theme_1.css) `
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
`;
const bottomRight = (0, Theme_1.css) `
  bottom: 0;
  right: 0;
`;
const getPosition = (position) => {
    switch (position) {
        case 'topLeft':
            return topLeft;
        case 'topCenter':
            return topCenter;
        case 'topRight':
            return topRight;
        case 'bottomLeft':
            return bottomLeft;
        case 'bottomCenter':
            return bottomCenter;
        case 'bottomRight':
            return bottomRight;
        default:
            return bottomCenter;
    }
};
const Position = Theme_1.styled.div `
  .fadeOut {
    animation-name: ${fadeOut};
    animation-duration: ${({ duration }) => `${duration}ms`};
    opacity: 0;
  }
  display: flex;
  ${(props) => getPosition(props.position)};
  position: fixed;
  padding: 8px;
  z-index: 10000;
`;
const Container = Theme_1.styled.div `
  display: flex;
  align-items: center;
  width: ${({ width }) => width};
  height: 48px;
  border-radius: 2px;
  border: none;
  font-weight: lighter;
  font-family: ${({ theme }) => theme.font.family.proximaNova};
  font-size: 14px;
  background-color: ${({ theme }) => theme.colors.gray[90]};
  color: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  z-index: 99999;
  opacity: 1;
  justify-content: space-between;
  animation: ${fadeIn} 0.3s ease-in-out;
`;
const Message = Theme_1.styled.div `
  padding: 4px 10px 4px 24px;
  text-align: left;
  width: 100%;
`;
const SnackbarButton = Theme_1.styled.div `
  color: ${({ theme }) => theme.colors.blue[30]};
  font-family: ${({ theme }) => theme.font.family.proximaNova};
  font-size: ${({ theme }) => theme.font.size.xsmall};
  font-weight: ${({ theme }) => theme.font.weight.semiBold};
  white-space: nowrap;
  cursor: pointer;
  padding-right: 24px;
  user-select: none;
`;
const StatusBar = Theme_1.styled.div `
  background-color: ${({ theme, variant }) => {
    if (variant === 'error') {
        return theme.colors.red[50];
    }
    if (variant === 'success') {
        return theme.colors.green[50];
    }
    if (variant === 'info') {
        return theme.colors.blue[50];
    }
    return;
}};
  width: 6px;
  height: 100%;
`;
const Snackbar = ({ duration = 4000, position = 'bottomCenter', width = '400px', message, buttonTitle, buttonOnClick, onClose, open, variant, }) => {
    (0, react_1.useEffect)(() => {
        if (!open) {
            return;
        }
        const timer = setTimeout(() => {
            onClose && onClose();
        }, duration);
        return () => {
            clearTimeout(timer);
        };
    }, [open]);
    if (!open) {
        return null;
    }
    return (React.createElement(Position, { position: position, duration: duration },
        React.createElement(Container, { position: position, className: "fadeOut", width: width },
            variant && React.createElement(StatusBar, { variant: variant }),
            React.createElement(Message, null, message),
            buttonTitle && (React.createElement(SnackbarButton, { onClick: buttonOnClick }, buttonTitle)))));
};
exports.Snackbar = Snackbar;
//# sourceMappingURL=Snackbar.js.map